import DocsContainer from './docs-container';

export default DocsContainer;
